var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container"},[_c('div',{staticClass:"alert-style",attrs:{"width":"80%"}},[_c('v-icon',[_vm._v(" mdi-alert-circle-outline ")]),_vm._v(" No Widgets are available ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }